import React from 'react';
import { AdFileSize } from '@ligr/api-v2';
import { adSizes } from '@ligr/themes';
export const animations = {
    show: [
        {
            refs: ['adGroup'],
            duration: 0.35,
            from: { autoAlpha: 0, y: 90 },
            to: { y: 0, autoAlpha: 1 }
        }
    ],
    hide: 'reverseShow'
};
export const dataSpec = {
    adSize: '$graphicProps.adSize',
    adUrl: '$graphicProps.adUrl'
};
const getAdTransform = (size) => ({
    [AdFileSize.small]: { x: 86, y: 1080 - 86 - 70 },
    [AdFileSize.medium]: { x: 86, y: 1080 - 86 - 70 },
    [AdFileSize.long]: { x: 0, y: 1080 - 140 },
    [AdFileSize.large]: { x: 0, y: 1080 - 270 },
    [AdFileSize.xLarge]: { x: 0, y: 1080 - 410 },
    [AdFileSize.square]: { x: 86, y: 1080 - 86 - 150 },
    [AdFileSize.banner]: { x: 86, y: 1080 - 86 - 150 }
}[size] || { x: 0, y: 0 });
export const getAnimPath = (graphicProps, data, current) => [(graphicProps === null || graphicProps === void 0 ? void 0 : graphicProps.adSize) ? 'default' : undefined].filter(val => val);
export const Ad = props => {
    const { rootStyle, type = 'image' } = props;
    const transform = getAdTransform(props.fieldData.adSize);
    return (React.createElement("svg", { width: (rootStyle === null || rootStyle === void 0 ? void 0 : rootStyle.width) || '100%', height: (rootStyle === null || rootStyle === void 0 ? void 0 : rootStyle.height) || '100%', viewBox: "0 0 1920 1080" },
        React.createElement("g", { ref: props.setRef('adGroup') },
            React.createElement("g", { transform: `translate(${transform.x},${transform.y})` }, props.fieldData.adUrl && props.fieldData.adSize && (React.createElement("g", { ref: props.setRef('adImage') }, type === 'image' && (React.createElement("image", { width: adSizes[props.fieldData.adSize].width, height: adSizes[props.fieldData.adSize].height, xlinkHref: props.fieldData.adUrl }))))))));
};
export const detachedAd = {
    animations: { default: animations },
    component: Ad,
    dataSpec,
    getAnimPath,
    name: 'DetachedAd',
    imageAdSizes: [
        AdFileSize.small,
        AdFileSize.medium,
        AdFileSize.long,
        AdFileSize.large,
        AdFileSize.xLarge,
        AdFileSize.banner,
        AdFileSize.square
    ],
    delayMap: {}
};
export const imageAdSizes = [
    AdFileSize.banner,
    AdFileSize.small,
    AdFileSize.medium,
    AdFileSize.square,
    AdFileSize.large,
    AdFileSize.xLarge,
    AdFileSize.long
];
//# sourceMappingURL=index.js.map